var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_3010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25V5.88269V4.41154V2.94038C0 1.31731 1.1197 0 2.49863 0H22.4876C23.8666 0 24.9863 1.31731 24.9863 2.94038V4.41154V5.88269V25H0ZM3.74794 1.47115C3.0577 1.47115 2.49863 2.12885 2.49863 2.94038C2.49863 3.75385 3.0577 4.41154 3.74794 4.41154C4.43819 4.41154 4.99725 3.75385 4.99725 2.94038C4.99725 2.12885 4.43819 1.47115 3.74794 1.47115ZM7.49588 1.47115C6.80564 1.47115 6.24657 2.12885 6.24657 2.94038C6.24657 3.75385 6.80564 4.41154 7.49588 4.41154C8.18613 4.41154 8.7452 3.75385 8.7452 2.94038C8.7452 2.12885 8.18613 1.47115 7.49588 1.47115ZM11.2438 1.47115C10.5536 1.47115 9.99451 2.12885 9.99451 2.94038C9.99451 3.75385 10.5536 4.41154 11.2438 4.41154C11.9341 4.41154 12.4931 3.75385 12.4931 2.94038C12.4931 2.12885 11.9341 1.47115 11.2438 1.47115ZM23.737 5.88269H1.24931V23.5288H23.737V5.88269ZM6.24657 20.5885H3.74794V16.1769H6.24657V20.5885ZM11.2438 20.5885H8.7452V13.2346H11.2438V20.5885ZM16.2411 20.5885H13.7425V8.82308H16.2411V20.5885ZM21.2383 20.5885H18.7397V13.2346H21.2383V20.5885Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_3010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOverview);
export default __webpack_public_path__ + "static/media/ic_overview.9422f4f555b338af56624890d088fd97.svg";
export { ForwardRef as ReactComponent };